// extracted by mini-css-extract-plugin
module.exports = {"tel":"telephone_tel__3B32J"};